import { render, staticRenderFns } from "./AppWidget.vue?vue&type=template&id=4a3abedb&scoped=true"
import script from "./AppWidget.vue?vue&type=script&lang=js"
export * from "./AppWidget.vue?vue&type=script&lang=js"
import style0 from "./AppWidget.vue?vue&type=style&index=0&id=4a3abedb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3abedb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a3abedb')) {
      api.createRecord('4a3abedb', component.options)
    } else {
      api.reload('4a3abedb', component.options)
    }
    module.hot.accept("./AppWidget.vue?vue&type=template&id=4a3abedb&scoped=true", function () {
      api.rerender('4a3abedb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/designer/widgets/AppWidget.vue"
export default component.exports